import customAxios from "../../customHook/customAxios";

import { getAuthHeader } from '../../utils';

export const v4_leave_applications = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/leave/applications/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v4_change_leave_application_staus = async (model, leaveId) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v4/leave/applications/${leaveId}`;
    return customAxios.patch(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}
